import { useHistory, useParams } from 'react-router-dom';
import { routes } from 'flow/types/routes';
import Page from 'flow/components/Setting/Page';
import useAppContext from 'flow/hooks/useAppContext';
import RouteLink from 'flow/components/ui-components/RouteLink';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { generatePath } from 'flow/utils/router-utils';

const CallRouting = () => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();

    return (
        <Page
            header="settings.callrouting.title"
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.softphone.advanced'], {
                        extensionKey,
                    }),
                )
            }
        >
            <RouteLink
                to={generatePath(
                    routes['settings.softphone.advanced.callrouting.type'],
                    { extensionKey, type: 'blocked_in' },
                )}
                iconKey="incoming"
            >
                {i18next.t('settings.callrouting.incoming')}
            </RouteLink>

            <RouteLink
                to={generatePath(
                    routes['settings.softphone.advanced.callrouting.type'],
                    { extensionKey, type: 'blocked_out' },
                )}
                iconKey="outgoing"
            >
                {i18next.t('settings.callrouting.outgoing')}
            </RouteLink>

            <RouteLink
                to={generatePath(
                    routes['settings.softphone.advanced.callrouting.type'],
                    { extensionKey, type: 'priority' },
                )}
                iconKey="highPriority"
            >
                {i18next.t('settings.callrouting.priority')}
            </RouteLink>
        </Page>
    );
};

export default CallRouting;
